import { DateTime } from "luxon";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import MetaChip from "../../../../components/UIToolkit/Badges/MetaChip";
import { cmsDeadline } from "../../network/networkMath";
import { usePbjNetwork } from "../../network/PbjNetworkContext";

/** Below this many days to the CMS deadline the chip turns from a note into a warning. */
const DEADLINE_WARNING_DAYS = 14;

/** When CMS needs the quarter's file, and how many days are left — or that the date has passed. */
export const CmsDeadlineChip: FC<{ committedEnd: string }> = ({ committedEnd }) => {
	const { t, i18n } = useTranslation();
	const { homeDepartmentId, buildingTimezone } = usePbjNetwork();
	// The quarter and "today" are the header department's days, like every other PBJ date on the page.
	const zone = buildingTimezone(homeDepartmentId);
	const deadline = cmsDeadline(committedEnd, zone);
	const daysLeft = Math.ceil(deadline.diff(DateTime.now().setZone(zone).startOf("day"), "days").days);
	const date = deadline.setLocale(i18n.language).toLocaleString(DateTime.DATE_MED_WITH_WEEKDAY);
	return (
		<MetaChip
			tone={daysLeft >= 0 && daysLeft <= DEADLINE_WARNING_DAYS ? "warning" : "neutral"}
			label={daysLeft < 0 ? t("pbj_model.network.summary.deadline_passed", { date }) : t("pbj_model.network.summary.deadline", { date, count: daysLeft })}
			dataTestId="pbj-network-summary-deadline"
		/>
	);
};
